 
import * as yup from 'yup'
export const SignupSchema = yup.object().shape({
    firstname: yup.string().max(15).required('first name is a required field'),
    lastname: yup.string().max(15).required('last name is a required field'),
    email: yup.string().email().required('email is a required field'),
    password: yup.string().min(5).max(20).required('password is a required field'),
   
})